<template>
    <div class="[ c-form-item ]" :class="[{'c-form-item--error': error, 'c-form-item--horizontal': horizontal}]">
        <v-label :custom-class="{customLabelClass: customLabelClass, 'u-margin-top-none': true}" :id="`${_uid}-`+name" v-if="hasSlotData('label')">
            <slot name="label"></slot>
        </v-label>
        <div class="[ c-switch ]" :class="`${size ? `c-switch--${size}` : ''} ${error ? 'error' :''}`">
            <input :disabled="readOnly" class="c-switch__input" type="checkbox" v-model="picked" :id="`${_uid}-`+name">
            <label :class="{'c-switch__item': true, 'is-checked': picked}" :for="`${_uid}-`+name"><span class="u-hidden-visually">test</span></label>
        </div>
        <v-error v-if="error">
            <slot name="error">{{ error }}</slot>
        </v-error>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VLabel from './Label.vue'
    import VInput from './Input.vue'
    import VError from './Error.vue'

    export default {
        props: {
            'name': String,
            'custom-label-class': String,
            'custom-class': String,
            'error': Object,
            'value': Boolean,
            'size': String,
            'horizontal': {type: Boolean, default: true},
            readOnly: {type: Boolean, default: false}
        },
        components: {
            VLabel,
            VInput,
            VError
        },
        computed: {
            picked: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            }
        },
        // Why watcher when there is a getter and setter
        // watch: {
        //     picked() {
        //         this.$emit('input', this.picked);
        //     }
        // },
        methods: {
            hasSlotData(name) {
                if (name) {
                    return this.$slots[name];
                }
                return this.$slots.default;
            },
        }
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-switch__input {
        @include visually-hidden();

        &:focus{
            + .c-switch__item{
                &:after{
                    box-shadow: 0 0 0 3px rgba($color-base, .5), 0 2px 4px 0 rgba($color-base, .1);
                }
            }
        }

        + .c-switch__item {
            outline: 0;
            display: block;
            width: em(42px);
            height: em(28px);
            position: relative;
            cursor: pointer;
            user-select: none;
            &:after,
            &:before {
                position: relative;
                display: block;
                content: "";
                width: 50%;
                height: 100%;
            }

            &:after {
                left: 0;
            }

            &:before {
                display: none;
            }
        }

        &:checked + .c-switch__item:after {
            left: 50%;
        }
        + .c-switch__item {
            background: palette(color-neutral, x-light);
            border-radius: 2em;
            padding: em($global-spacing-unit-tiny);
            transition: all .4s ease;
            box-shadow: inset 0 0 0 1px rgba($color-base, .2);
            &:after {
                border-radius: 50%;
                background: #fff;
                transition: all .2s ease;
                box-shadow: 0 0 0 3px rgba($color-base, .2), 0 2px 4px 0 rgba($color-base, .1);
            }
        }

        &:checked + .c-switch__item {
            background: $color-success;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/form/Switch.vue